import api from './axiosInstance';

export const paymentApi = {
  getDues: (params = {}) => api.get('/payments/dues', {params}),
  create: data => api.post('/payments', data),
  getHistory: (params = {}) => api.get('/payments', {params}),
  getDetail: id => api.get(`/payments/${id}`),

  // Easebuzz payment gateway
  initiatePayment: data => api.post('/payments/initiate', data),
  bulkInitiatePayment: data => api.post('/payments/bulk-initiate', data),
  verifyPayment: data => api.post('/payments/verify', data),
};
